import { render, staticRenderFns } from "./ExceptionWithImg.vue?vue&type=template&id=5ab7637a&scoped=true&"
import script from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
export * from "./ExceptionWithImg.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionWithImg.vue?vue&type=style&index=0&id=5ab7637a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7637a",
  null
  
)

export default component.exports